// SignupForm.js
import React, { useEffect } from 'react';
import { loadOutseta } from '../Outseta';
// import * as chrono from 'chrono-node';
// import { RRule } from "rrule";

const LoginForm = ({upgrade = false}) => {
    const OPTIONS = {
        domain: "lifetab.outseta.com",
        load: "auth,profile",
        auth: {
            widgetMode: "login",
            id: "login_embed",
            mode: "embed",
            selector: "#outseta-login-form"
        }
    };

    const removeWarning = (e) => {
        if(e.target.closest('.o--Button--btn')){
            document.querySelector('.warning')?.remove();
        }
    }

    useEffect(() => {
        loadOutseta(OPTIONS).then((outsetaObject) => {
            outsetaObject.getUser();
            if(upgrade){
                const intervalId = setInterval(() => {
                    if(document.querySelector('.o--Button--btn')){
                        clearInterval(intervalId);
                        document.addEventListener('click', removeWarning);
                    }
                }, 1000);
            }
        });

        return () => {
            upgrade && document.removeEventListener('click', removeWarning);
        };
    }, []);

    // const recurrencePatterns = [
    //     { regex: /every day/i, rule: { freq: RRule.DAILY } },
    //     { regex: /every week/i, rule: { freq: RRule.WEEKLY } },
    //     { regex: /every month/i, rule: { freq: RRule.MONTHLY } },
    //     { regex: /every year/i, rule: { freq: RRule.YEARLY } },
    //     {regex: /every monday/i, rule: {freq: RRule.WEEKLY, byweekday: RRule.MO}},
    //     {regex: /every tuesday/i, rule: {freq: RRule.WEEKLY, byweekday: RRule.TU}},
    //     {regex: /every wednesday/i, rule: {freq: RRule.WEEKLY, byweekday: RRule.WE}},
    //     {regex: /every thursday/i, rule: {freq: RRule.WEEKLY, byweekday: RRule.TH}},
    //     {regex: /every friday/i, rule: {freq: RRule.WEEKLY, byweekday: RRule.FR}},
    //     {regex: /every saturday/i, rule: {freq: RRule.WEEKLY, byweekday: RRule.SA}},
    //     {regex: /every sunday/i, rule: {freq: RRule.WEEKLY, byweekday: RRule.SU}},
    //     { regex: /every (\d+)(st|nd|rd|th)? (\w+)/i, rule: (match) => ({
    //         freq: RRule.WEEKLY,
    //         interval: parseInt(match[1], 10),
    //         byweekday: RRule[match[3].toUpperCase().slice(0, 2)],
    //         }),
    //     },
    // ];

    // const parseTask = (task) => {
    //     // Step 1: Extract Single Date (if any)
    //     const parsedDate = chrono.parse(task);

    //     // Step 2: Detect Recurrence
    //     let recurrenceRule = null;
    //     for (const { regex, rule } of recurrencePatterns) {
    //         const match = task.match(regex);
    //         if (match) {
    //             recurrenceRule = new RRule(typeof rule === "function" ? rule(match) : rule).toString();
    //             break;
    //         }
    //     }

    //     return {
    //         date: parsedDate[0].start.date().toString() || null,
    //         text: parsedDate[0].text || null,
    //         index: parsedDate[0].index || null,
    //         rrule: recurrenceRule || null,
    //     };
    // };

    ////console.log('CRONO: ', parseTask('Check out email on January 1st 2026.'));

    return (
        <div id="outseta-signup-form-wrapper">
            <div id="outseta-login-form" style={{textAlign: 'center'}}>
                <h3 style={{textAlign: 'center'}}>Loading ... kindly wait.</h3>
            </div>
            <div className='flex justify-content-center gap-[5px] font-inter'><span className='opacity-50'>New to Lifetab?</span> <a href="/signup">Sign Up</a></div>
        </div>
    );
};

export default LoginForm;
